// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"78acb93e","330":"394a64ad","710":"a8b0868e","804":"08226698","828":"4ca07792","855":"03ffc54a"}[chunkId] + ".chunk.css";
};